import { PropsWithChildren } from "react";
import { Asset, CashoutTransactionStatus } from "../../types/types";
import { useTranslation } from "react-i18next";
import { IonItem, IonLabel, IonNote, IonThumbnail,IonText } from "@ionic/react";
import NumberFormat from "react-number-format";
import moment from "moment";


interface CashoutProps extends PropsWithChildren {
    operation: any;
    onClick: Function;
    asset: Asset;
}

const CashoutListItem: React.FC<CashoutProps> = ({ operation, asset, onClick }) => {

    const { t, i18n } = useTranslation();

    return (
        <>

            <IonItem lines="none" onClick={() => { onClick() }}>

                <IonItem lines='none'>

                    <IonThumbnail slot="start" className="cashoutThumbnailMoneyGram">
                        <img src={`/assets/img/moneygram.png`} />
                    </IonThumbnail>
                    <IonLabel className="accountsPage_AssetLabel">
                    <IonText className="ion-text-wrap">

                    <h5>
                            {t('operations.cashout.LABEL')}
                        </h5>

                    </IonText>
                        

                        <IonNote className="operationsItem_IonNote ion-text-wrap"

                            color={(operation.info.status === CashoutTransactionStatus.pending_user_transfer_start || operation.info.status === CashoutTransactionStatus.pending_user_transfer_complete ||
                                operation.info.status === CashoutTransactionStatus.pending_user) ? 'warning' : operation.info.status === CashoutTransactionStatus.failed ? 'danger'
                                : operation.info.status === CashoutTransactionStatus.completed ? 'success' : 'medium'
                            }

                        >

                            {
                                operation.info.status === CashoutTransactionStatus.pending_user_transfer_start ? t('cashout.page.PENDING_USER_TRANSFER_START_MESSAGE')
                                    : operation.info.status === CashoutTransactionStatus.pending_user_transfer_complete ? t('cashout.page.PENDING_USER_TRANSFER_COMPLETE')
                                        : operation.info.status === CashoutTransactionStatus.pending_user ? t('cashout.page.PENDING_USER')
                                            : operation.info.status === CashoutTransactionStatus.failed ? t('cashout.page.FAILED')
                                                : operation.info.status === CashoutTransactionStatus.completed ? moment.unix(operation.timestamp).format("D MMM YYYY")
                                                    : operation.info.status

                            }



                        </IonNote>
                    </IonLabel>

                </IonItem>

                <IonLabel slot='end'>
                <IonText color={operation.isRecipient ? 'primary' : "danger"} className="ion-text-wrap">
                    <h4 >
                        <NumberFormat value={operation.info.amount_in.toString()}
                            prefix={operation.kind === 'deposit' ? "+ " : "- "}
                            displayType={'text'}
                            thousandSeparator={true}
                            decimalSeparator="."
                            decimalScale={asset.decimal_places}
                            fixedDecimalScale={true}
                            suffix={` ${operation.token.code}`}

                        />

                    </h4>
                    </IonText>
                </IonLabel>
            </IonItem>

        </>
    )
}

export default CashoutListItem